import { render, staticRenderFns } from "./SidebarDashboard.vue?vue&type=template&id=1ca57c0b"
import script from "./SidebarDashboard.vue?vue&type=script&lang=js"
export * from "./SidebarDashboard.vue?vue&type=script&lang=js"
import style0 from "./SidebarDashboard.vue?vue&type=style&index=0&id=1ca57c0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports